import { Modal, ModalProps } from "react-bootstrap";
import { getPortraitStageContainer } from "../compoment/PortraitStage";

interface IdleScreenTimeModalProps extends ModalProps {
  onHide: () => void;
  onContinue: () => void;
  onQuit: () => void;
}

const IdleScreenTimeModal = ({
  onHide,
  onContinue,
  onQuit,
  ...props
}: IdleScreenTimeModalProps) => {
  return (
    <Modal
      container={getPortraitStageContainer}
      {...props}
      onHide={onHide}
      backdrop="static"
      className="idleModal"
      keyboard={false}
      centered
      scrollable={false}
    >
      <Modal.Body>
        <div className="otpModalBody mt-2">
          <div className="header">
            Are you still there?
          </div>
          <div className="description">
            Your session is about to expire due to inactivity. Continue now to keep creating.
          </div>

          <div className="d-flex gap-3 mx-5">
            <button type="button" className="btnPrimary w-100" onClick={onContinue}>
              Continue
            </button>
            <button type="button" className="btnOutline w-100" onClick={onQuit}>
              Quit
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default IdleScreenTimeModal;
